import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms"; // , FormGroup, FormControl, Validators
import { DataService } from "../../services/data.service";
import { CommonJs } from "../../common/common-js";
import { AppConfigs } from "../../common/app-configs";
import { TenantService } from "../../services/tenant.service";
declare var $: any;
import * as _ from "lodash";

import { Renderer2 } from '@angular/core';
import { VaniToasterService } from 'src/app/services/vani-toaster.service';

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  public isSuperAdmin: boolean;
  public isStandAlone: boolean = false;
  loginForm!: FormGroup;
  isLoading = false;

  //public Settings:any;

  login: Login;
  errors: any;
  focused: string = "";

  loginImages: LoginImages;
  clienCode: any;
  uploadUrl = this.appConfigs.getUploadUrl();

  projectPer = {};
  projectrole = {};
  projectrolestype = {};
  showPassword: boolean = false;


  constructor(
    private titleService: Title,
    public router: Router,
    private fb: FormBuilder,
    public commonJs: CommonJs,
    public appConfigs: AppConfigs,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private toastrService: VaniToasterService,
    private renderer: Renderer2,
    private tenantService: TenantService
  ) {
    //localStorage.setItem('token','');
    var standA = false;
    let role = localStorage.getItem("role");

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isSuperAdmin = event.url.indexOf("superadmin") !== -1;
      }
    });
    if (localStorage.getItem("token")) {
      this.router.navigate(["/dashboard"]);
    }
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((val) => {
      this.login = {
        email: "",
        password: "",
        client_code: this.activatedRoute.snapshot.paramMap.get("access_code"),
      };
      if (this.isSuperAdmin) {
        this.clienCode = "superadmin";
      } else {
        // this.clienCode =
          // "ac/" + this.activatedRoute.snapshot.paramMap.get("access_code");
      }
      this.loginImages = {
        logo: "",
        logo_image: "",
        banner: "",
        banner_image: "",
      };

      this.dataService
        .getDataById("checkLoginImages")
        .subscribe(
          (success:any) => {
            this.uploadUrl = this.uploadUrl.replace("null/", "");
            if (success.data.logo_url != "") {
              this.loginImages.logo = success.data.logo_url;
              this.loginImages.logo_image = success.data.logo_image;
            }

            if (success.data.banner_url != "") {
              this.loginImages.banner = success.data.banner_url;
              this.loginImages.banner_image = success.data.banner_image;
              const element = document.querySelector('.login-wrapper');
              this.renderer.setStyle(element, 'background-image', `url(${this.bannerImage(success.data.banner_url)})`);
            }

            localStorage.setItem(
              "currentAccountImages",
              JSON.stringify(this.loginImages)
            );
          },
          (rejected) => {
            //console.log(rejected);
          }
        );
    });
    this.titleService.setTitle("Login");
    this.focused = "focused";
    this.isStandAlone = JSON.parse(localStorage.getItem("config"));

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  bannerImage(imageUrl: any) {
    return imageUrl;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  // Helper method to check if a form control has a specific error
  hasError(controlName: string, errorName: string): boolean {
    const control = this.loginForm.get(controlName);
    return control ? control.hasError(errorName) && (control.touched || control.dirty) : false;
  }

  onSubmit() {
    console.log("yes",this.loginForm.invalid)
    this.isLoading = true;
    localStorage.removeItem("currentTask");
    localStorage.removeItem("projectRoles");
    localStorage.removeItem("projectRoleType");
    localStorage.removeItem("projectPermissions");
    let that = this;
    // if (form.value.client_code == undefined) {
    //   form.value.client_code = "";
    //   form.value.isStandAlone = this.isStandAlone;
    // }
    // form.value.client_code = this.activatedRoute.snapshot.paramMap.get("access_code");
    // Stop here if form is invalid

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    var data = this.loginForm.value
    data.isSuperAdmin = this.isSuperAdmin;

    // only offline user login
    // form.value.is_offline = false;
    // form.value.offline_key = "L8PyRXCDT5";
    //
    this.dataService.login("login", data).subscribe((success:any) => {
    console.log("test login")
      if (success.success) {
        let role = success.results.user.slug;
        localStorage.setItem("token", success.results.user.Token);
        localStorage.setItem("userId", success.results.user.id);
        localStorage.setItem("user", JSON.stringify(success.results.user));
        localStorage.setItem("role", role);
        localStorage.setItem("client_code", success.results.user.client_code);
        localStorage.setItem(
          "permissions",
          JSON.stringify(success.permissions)
        );

        let st = localStorage.getItem("standalone");
        if (role != "superadmin" && st != "1") {
          // Use tenant service to set tenant
          // this.tenantService.setTenant(success.results.user.client_code);
        } else if (role == "superadmin" || (this.isSuperAdmin && st == "1")) {
          // For superadmin, no tenant needed
        } else {
          // this.tenantService.setTenant("standalone");
        }

        // this.dataService.setHeaders();
        this.dataService.setHeadersForFile();
        this.commonJs.getPermissions();
        this.commonJs.getAllSettings(true);
        //commented 19-8-20
        // this.getProjectRole();

        /*if(role == 'superadmin' || role == 'admin'){
        that.router.navigate(['/'+this.commonJs.getClientCodePrefix()+'/dashboard']);
        }else{
          that.router.navigate(['/'+this.commonJs.getClientCodePrefix()+'/projects/overview']);
        }*/

        if(role != "superadmin"){
          this.projectListByUser();
          this.getStatusList();
        }

        // Use tenant service for navigation if not superadmin
        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            console.log('Navigated to:', event.url);
          }
        });
        // console.log(role, this.router);
        if (role !== "superadmin") {
          // this.tenantService.navigateToTenantRoute(["dashboard"]);
          this.router.navigate(['/dashboard']);
        } else {
          // console.log('here');
          // this.router.navigate([
          // this.router.navigate(['/dashboard']);
          that.router.navigate([
            "/superadmin/dashboard",
         ]);

        }
        this.isLoading = false;
      } else {
        if (success.code == 422) {
          this.toastrService.notify('error', '', success.error.isOnlineAccess);
        }
      }
    },
      (error:any) => {
        console.log('Full error:', error());
        this.isLoading = false;
        var error = error()
        // Handle validation errors (422)
        if (error && error.status === 422) {
          if (error.error && error.error.error && error.error.error.isOnlineAccess) {
            this.toastrService.notify('error', '', error.error.error.isOnlineAccess);
          } else if (error.error && error.error.error && error.error.error.password) {
            this.toastrService.notify('error', '', error.error.error.password);
          } else if (error.error && error.error.error) {
            // Handle other validation errors
            const errorMessage = Object.values(error.error.error).join(', ');
            this.toastrService.notify('error', '', errorMessage);
          } else if (error.error && error.error.message) {
            this.toastrService.notify('error', '', error.error.message);
          }
        }
        // Handle expired account (499)
        else if (error && error.status === 499) {
          //const message = error.error && error.error.message ? error.error.message : 'It seems your account is expired. Please contact support.';
          //this.toastrService.notify('error', '', message);
        }
        // Handle other errors
        else {
          let errorMessage = 'An error occurred during login. Please try again.';
          if (error.error && error.error.message) {
            errorMessage = error.error.message;
          } else if (error.message) {
            errorMessage = error.message;
          }
          this.toastrService.notify('error', '', errorMessage);
          
          if (error.error && error.error.error) {
            this.errors = error.error.error;
          }
        }
      }
    );
  }

  clearFieldError(field: string) {
    if (this.errors && this.errors[field]) {
      delete this.errors[field];
    }
  }

  projectListByUser() {



    this.dataService.getListTotal('projectListByUser')
      .subscribe((success:any) => {
        this.dataService.getProjectListByUser = success.data;
        this.dataService.getAllProjectList();
      }, (rejected) => {
        // //console.log(rejected);
      });

  }

  getStatusList() {
    // this.dataService.getDataById("getStatusList/").subscribe(
    //   (success:any) => {
    //     this.dataService.allStatusList = success.data;
    //   },
    //   (error) => {
    //   }
    // );
    return new Promise((resolve, rejected) => {

      this.dataService.getOtherData('getStatusList', {})
        .subscribe((success:any) => {
          this.dataService.allStatusList = success.data;
          resolve(200);
        }, (rejected) => {
        });

    });
  }
}

interface Login {
  email: string;
  password: string;
  client_code: string;
}

interface LoginImages {
  logo: string;
  logo_image: string;
  banner: string;
  banner_image: string;
}

